import { render, staticRenderFns } from "./FormAssignmentSKPBawahan.vue?vue&type=template&id=1f8b4072&lang=html&"
import script from "./FormAssignmentSKPBawahan.vue?vue&type=script&lang=js&"
export * from "./FormAssignmentSKPBawahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports